@if (titleTemplate) {
    <h2 class="gup-O-titrage__title">
        <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
    </h2>
}

<!-- above searchbar -->
@if (!displayFilters && aboveSearchbarContentTemplate) {
    <ng-container *ngTemplateOutlet="aboveSearchbarContentTemplate"></ng-container>
}

<!-- barre de recherche-->
@if (canDisplaySearchBar) {
    <section class="gup-C-searchBar">

        @if (!searchbarContentTemplate) {
            <kal-input (keydown.enter)="applyFilters()"
                       [formControl]="searchbarControl"
                       (iconClicked)="applyFilters()"
                       (keyup.enter)="applyFilters()"
                       class="gup-O-search"
                       icon="search"
                       [placeholder]="searchBarPlaceholder">
            </kal-input>
        } @else {
            <ng-container *ngTemplateOutlet="searchbarContentTemplate"></ng-container>
        }

        @if (filtersComponent) {
            <kal-button (click)="toggleFilters()"
                        [disabled]="loading$|async"
                        class="gup-C-searchBar__filterBtn">
                <kal-icon><i class="material-icons">tune</i></kal-icon>
                <span>Filtrer
                    @if (dataSource.nbOfFilters; as total) {
                        ({{ total }})
                    }
                </span>
            </kal-button>
        }

        @if (exportHeaders) {
            <kal-button (click)="exportData()" [disabled]="(loading$|async) || (!dataSource)"
                        class="gup-C-searchBar__filterBtn">
                <kal-icon><i class="material-icons">file_upload</i></kal-icon>
                <span>Exporter</span>
            </kal-button>
        }

        <!-- after searchbar buttons -->
        @if (afterSearchbarButtonsTemplate) {
            <ng-container *ngTemplateOutlet="afterSearchbarButtonsTemplate"></ng-container>
        }

        @if (displayCount) {
            <div class="gup-C-searchBar__filterBtn gup-U-color--500">
                @if ({ count: (dataSource.nbOfElements$ | async) ?? dataSource.nbOfElements }; as ctx) {
                    <span>
                        {ctx.count, plural,
                            =0 { Résultat : }
                            one { Résultat : }
                            other { Résultats : }}
                    </span>
                    <ng-container *ngTemplateOutlet="listingCountResultsLabel ? listingCountResultsLabel.templateRef : defaultCountResultsLabelTemplate; context: {nbOfElements: ctx.count}"></ng-container>
                    <ng-template #defaultCountResultsLabelTemplate>
                        {{ ctx.count }}
                    </ng-template>
                }
            </div>
        }

    </section>
} @else {
    <ng-container *ngTemplateOutlet="listingActionGrouped?.template"></ng-container>
}

<!-- affichage des filtres -->
@if (filtersComponent) {
    <section class="filters" [class.hidden]="!displayFilters">
        <kal-card (dismissed)="closeFilters()"
                  [dismissable]="true">

            <kal-card-title>
                Filtrer
            </kal-card-title>

            <kal-card-content>
                <ng-content></ng-content>
            </kal-card-content>

            <kal-card-actions>
                <kal-button (click)="applyFilters()"
                            [id]="key + '_filters_apply'"
							[disabled]="filtersComponent.form.invalid"
                            kalTheme="primary">
                    Appliquer
                </kal-button>

                <kal-button (click)="cancelFilters()"
                            [id]="key + '_filters_cancel'"
                            kalTheme="secondary">
                    Annuler
                </kal-button>

                <kal-button (click)="resetFilters()"
                            [id]="key + '_filters_reinit'"
                            kalTheme="tertiary">
                    Réinitialiser
                </kal-button>
            </kal-card-actions>
        </kal-card>
    </section>
}

<!-- above listing -->
@if (!displayFilters && headerTemplate) {
    <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
}

<!-- affichage du tableau -->
<section class="listing"
         [class.hidden]="displayFilters"
         [kalLoading]="dataSource.loading.change$|async"
         [kalLoadingMessage]="kalLoadingMessage">
    <ng-content select="kal-table"></ng-content>
    @if (betweenTableAndPagingTemplate) {
        <ng-container *ngTemplateOutlet="betweenTableAndPagingTemplate"></ng-container>
    }
    @if (paginate) {
        <kal-paginator [count]="dataSource.nbOfElements"
                       [datasource]="dataSource"
                       [size]="paginationSize"
                       (sizeChange)="paginationSizeChange.emit($event)"
                       [pagesToDisplay]="paginationPagesToDisplayList"
                       [rowsByPageList]="paginationRowsByPageList"></kal-paginator>
    }
</section>

<!-- below listing -->
@if (!displayFilters && footerTemplate) {
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
}
